import { prop } from "../../decorators/property";
import { AuthorizationModel } from "../../authentication/models/authorization-model";
import { AppSettings } from "../../app-settings";
import { Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";
import { ContainerHelper } from "../../shared/helpers/container-helper";

export class AlertsCourtModel extends Backbone.AssociatedModel {

    @prop() public Enabled: boolean;
    @prop() public CourtName: string;
    @prop() public CourtId: number;
    @prop() public DisplayJurisdiction: string;
    @prop() public Hidden: boolean;

    constructor(options?) {
        super(options);
    }

    public saveAlert() {
        const authService = ContainerHelper.AuthService;
        const user = authService.AppUser;
        return new Promise<any>((resolve, reject) => {
            $.ajax({
                beforeSend: AuthorizationModel.attachAuthorizationHeader,
                type: "POST",
                url: `${AppSettings.ApiUrlPrefix}alerts/savecourtalert`,
                data: {
                    Enabled: this.Enabled,
                    Recipient: user.FriendlyName + "<" + user.Email + ">",
                    Court: this.CourtName,
                    CourtId: this.CourtId
                }
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/models/alerts-court.ts